import SingletonStore from '@components/UtilComponents/SingletonStore';

export const store = new SingletonStore();
